export const suppressAnalyticsErrors = () => {
  const originalConsoleError = console.error
  const originalConsoleWarn = console.warn

  console.error = (...args: any[]) => {
    const message = args[0]?.toString() || ''
    if (
      message.includes('statscollector') ||
      message.includes('ERR_BLOCKED_BY_CLIENT') ||
      message.includes('agora.io/events') ||
      message.includes('sd-rtn.com')
    ) {
      return
    }
    originalConsoleError.apply(console, args)
  }

  console.warn = (...args: any[]) => {
    const message = args[0]?.toString() || ''
    if (
      message.includes('statscollector') ||
      message.includes('ERR_BLOCKED_BY_CLIENT') ||
      message.includes('agora.io/events') ||
      message.includes('sd-rtn.com')
    ) {
      return
    }
    originalConsoleWarn.apply(console, args)
  }

  const originalXHROpen = XMLHttpRequest.prototype.open
  XMLHttpRequest.prototype.open = function (
    method: string,
    url: string | URL,
    async?: boolean,
    user?: string | null,
    password?: string | null
  ) {
    if (
      typeof url === 'string' &&
      (url.includes('statscollector') ||
        url.includes('agora.io/events') ||
        url.includes('sd-rtn.com'))
    ) {
      return
    }
    return originalXHROpen.call(
      this,
      method,
      url.toString(),
      async ?? true,
      user,
      password
    )
  }

  const originalFetch = window.fetch
  window.fetch = function (input: RequestInfo | URL, init?: RequestInit) {
    const url =
      typeof input === 'string'
        ? input
        : input instanceof URL
          ? input.toString()
          : (input as Request).url
    if (
      url &&
      (url.includes('statscollector') ||
        url.includes('agora.io/events') ||
        url.includes('sd-rtn.com'))
    ) {
      return Promise.reject(new Error('Analytics request blocked'))
    }
    return originalFetch.call(this, input as RequestInfo, init)
  }
}

suppressAnalyticsErrors()
